import { Icon } from '@mis/sushi-tailwind-react';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from '../secondary-button/SecondaryButton';
import { TransparentButton } from '../transparent-button/TransparentButton';

interface CollapseButtonProps {
  isOpened: boolean;
  onClick: () => void;
  children?: React.ReactNode;
  mode?: 'secondary' | 'transparent';
}

const CollapseButton: React.FC<CollapseButtonProps> = (props) => {
  const ButtonElement = props.mode === 'secondary' ? SecondaryButton : TransparentButton;
  const { t } = useTranslation('button');
  return (
    <ButtonElement
      icon={<Icon className={classNames('mr-[-4px] duration-300 text-xl', { 'rotate-180': !props.isOpened })} name="expand_less" />}
      className="self-end px-2 py-0 font-normal"
      onClick={props.onClick}
    >
      {props.children || t('button:collapse')}
    </ButtonElement>
  );
};

CollapseButton.defaultProps = {
  mode: 'transparent',
};

export default CollapseButton;
